import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '../Elements'
import { Phone, Logo, LogoAr, LetterWhite } from '../AllImages'
import { Container, Row } from 'react-bootstrap'
import { ButtonWithIcon } from '../CustomElements'

import { Link } from 'react-scroll'
import { useTranslation } from 'react-i18next'
import { BsJustify, BsX } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import { Linkedin } from 'react-bootstrap-icons'
import LangChangeButton from '../../Languages/LangChangeButton'
import { NavDataConfig } from './HeaderData'
import i18n from '../../Languages/INEXT'
import ChangeButton from '../../Languages/ChangeButton'
const Header = () => {
    const navigate = useNavigate()
    
    const { t } = useTranslation();
    const [isSticky, setIsSticky] = useState(false);
    const [toggle, setToggle] = useState(false);
    const handleToggle = () => {
        setToggle(!toggle);
        const element = document.querySelector(".nav-bar-list");
        element.classList.toggle("showToggle");
    };
    const WhatsApp = () => {
        const phoneNumber = '+966505531205';
        const message = 'Hello, this is Al Asas';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
    const SocialLinkSnap = () => {
        window.open('#!', '_blank');
    };
    const SocialLinkLinkedIn = () => {
        window.open('#!', '_blank');
    };
    const SocialLinkInstagram = () => {
        window.open('https://www.instagram.com/sheelandmore?igsh=MW8xMHVzOHhsODUweg==', '_blank');
    };
    const SocialLinkTwitter = () => {
        window.open('https://x.com/sheelandmore?s=11', '_blank');
    };
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 1) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <>
            <HeaderContainer className={`${isSticky ? 'sticky' : ''} container-fluid`}>
                <Container>
                    <Row>
                        <Box className='nav-bar'>
                            <Box className='logoHeader' onClick={() => navigate('/')}>
                                {/* {i18n.language === "ar" ? <LogoAr /> : <Logo />} */}
                                <Logo />
                            </Box>
                            <Box className='nav-bar-list'>
                                {NavDataConfig.map((item, key) => (
                                    <Box key={key}>
                                        <Link to={item.to} spy={true} smooth={true} offset={-99} duration={500} activeClass="active" onClick={handleToggle}>{t(item.label)}</Link>
                                    </Box>
                                ))}
                            </Box>
                            <Box className='d-flex align-items-center headerBtnsContainer'>
                                <ButtonWithIcon className="headerWhatsapp" border="1px solid var(--themeColor)" padding='11px 24px' radius="8px" icon={Phone} label={t('Contact')} onClick={WhatsApp} />
                                <LangChangeButton color="var(--white)" iconColor="var(--white)" className="headerLang" />
                                <ChangeButton />
                                <span className="toggleBtn" onClick={handleToggle}>
                                    {toggle ? <BsX size={30} /> : <BsJustify size={30} />}
                                </span>
                            </Box>
                        </Box>
                    </Row>
                </Container>
            </HeaderContainer>
        </>
    )
}
const HeaderContainer = styled.header`
    -webkit-transition: all .3s ease-out 0s;
    transition: all .3s ease-out 0s;
    background: transparent;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;
    padding-top: 24px;
    padding-bottom: 24px;
    .logo{
        cursor:pointer;
    }
    .socialLinks{
        cursor: pointer;
    }
    .socialLinksContainer{
        display: flex;
        gap: 16px;
    }
    .nav-bar{
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
    }
    .nav-bar-list{
        display:flex;  
        align-items: center;
        gap: 3px;
    }
    .nav-bar-list a{
        color:var(--white);
        padding: 0px 17px;
        line-height: 40px;
        position: relative;
        font-size:14px;
        font-family: var(--familyRbtFlex);
        font-weight: var(--bold);
        text-transform: uppercase;
        border-radius: 8px;
        display: block;
        cursor: pointer;
        &:hover{
            background: var(--themeColor);
            font-family: var(--medium);
            color:var(--bg);
        }
        &:focus, &.active{
            background: var(--themeColor);
            font-weight: var(--semiBold);
            color:var(--bg);
        }
        
    }
    .headerBtnsContainer{
        gap: 16px;
    }
    body.rtl &{
        .nav-bar-list a{
            font-family: var(--arBold);
            font-size: 18px;
            &:hover{
                font-family: var(--arBold);
            }
            &:focus, &.active{
                font-family: var(--arBold);
            }
        }
    }
    @media (max-width: 1199px) {
        .nav-bar-list{
            gap: 0px;
        }
        .headerBtnsContainer{
            gap: 5px;
        }
        .headerWhatsapp button{
            padding: 11px 15px;
        }
    }
    
    @media (max-width: 767px) {
        
        .socialLinksContainer{
            display: none !important;
        }
    }
    @media (max-width: 640px) {
        padding-top: 15px;
        padding-bottom: 15px;
        .socialLinksContainer{
            gap: 8px;
        }
    }
    @media (max-width: 550px) {
        .socialLinksContainer{
            display: none !important;
        }
        /* .logoHeader{
            width: 130px;
            svg{
                width: 100%;
                height: auto;
            }
        } */
    }
    @media (max-width: 390px) {
        /* .headerWhatsapp{
            display: none !important;
        } */
    }
`
export default Header
